import { Box, createStyles, Group, Stack } from '@mantine/core';
import { IconSkeleton, TextSkeleton } from '@repo/foundations';

const useStyles = createStyles((theme) => ({
	card: {
		backgroundColor: theme.other.getColor('surface/primary/default'),
		borderRadius: theme.other.borderRadius.md,
		padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
		boxShadow: theme.shadows.sm,
	},
	resourceIcon: {
		backgroundColor: 'rgba(0, 0, 0, 0.05)',
		borderRadius: theme.other.borderRadius.sm,
		padding: theme.spacing['3xs'],
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: theme.other.space[7], // 28px
		height: theme.other.space[7], // 28px
	},
}));

export function ReferencedObjectCardSkeleton() {
	const { classes } = useStyles();

	return (
		<Box className={classes.card}>
			<Group spacing="sm" align="center" position="apart">
				<Group spacing="sm" align="center">
					<Box className={classes.resourceIcon}>
						<IconSkeleton size={16} />
					</Box>
					<Stack spacing="xs">
						<TextSkeleton size="sm" width="120px" />
						<TextSkeleton size="xs" width="80px" />
					</Stack>
				</Group>
			</Group>
		</Box>
	);
}
